<section>
  <h3>Embed code (Registration form only)</h3>
  <ngx-skeleton-loader *ngIf="isLoading" count="1" [theme]="skeletonTheme" animation="progress" aria-label="Loading embed code"></ngx-skeleton-loader>
  <div *ngIf="!isLoading" (click)="copyCode()" [ngClass]="{ 'show-status': formLinkStatus }" [attr.status]="formLinkStatus">
    {{ embeddedForm }}
  </div>
</section>
